import { render, staticRenderFns } from "./rankingVotes.vue?vue&type=template&id=0f9c4e91&scoped=true"
import script from "./rankingVotes.vue?vue&type=script&lang=js"
export * from "./rankingVotes.vue?vue&type=script&lang=js"
import style0 from "./rankingVotes.vue?vue&type=style&index=0&id=0f9c4e91&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_yhenekn6hnf4pbbtdhpnebbsqm/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9c4e91",
  null
  
)

export default component.exports